import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { CartDetailsComponent } from '@spartacus/cart/base/components'
import { Observable } from 'rxjs'
import { EbOrderEntry } from '../../interface/eb-order-entry.interface'

@Component({
    selector: 'eb-cart-details',
    templateUrl: './eb-cart-details.component.html',
    styleUrls: ['./eb-cart-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EbCartDetailsComponent extends CartDetailsComponent implements OnInit {
  entries$: Observable<EbOrderEntry[]>
  ngOnInit() {
    super.ngOnInit()
  }
}
